import { AUDIO_CUT_API_HOSTNAME } from "config/envConfig";
import localStorageInstance from "utils/LocalStorage";

import APIService from "../index";

const audioCutAPIInstance = APIService({
  baseURL: AUDIO_CUT_API_HOSTNAME,
});

audioCutAPIInstance.interceptors.request.use((config) => {
  if (!config?.skipAuthHeader) {
    config.headers["Authorization"] = localStorageInstance.getItem("authToken");
  }

  return config;
});

export default audioCutAPIInstance;
